import axios from '@/axios';

const RESOURCE_NAME = '/public-startups';

export default {
    getInfo(domain) {
        return axios.get(`${RESOURCE_NAME}/get-info?domain=${domain}`)
    },
}
